var map = {
	"./ICE/answer1.png": 614,
	"./ICE/answer2.png": 615,
	"./ICE/answer3.png": 616,
	"./ICE/arrowLeft.png": 619,
	"./ICE/arrowRight.png": 618,
	"./ICE/background.png": 617,
	"./ICE/crankshaft.png": 611,
	"./ICE/crankshaft1.png": 1847,
	"./ICE/fuel.png": 161,
	"./ICE/gas.png": 620,
	"./ICE/ignition.png": 621,
	"./ICE/indicator.png": 242,
	"./ICE/indicatorLine.png": 622,
	"./ICE/indicatorRpm.png": 623,
	"./ICE/kolba.png": 605,
	"./ICE/kolba2.png": 243,
	"./ICE/kolba3.png": 608,
	"./ICE/piston.png": 607,
	"./ICE/pistonBody.png": 610,
	"./ICE/pistonBody1.png": 1848,
	"./ICE/pistonHead.png": 609,
	"./ICE/sparkPlug.png": 160,
	"./ICE/spring.png": 606,
	"./ICE/stepsTable.png": 612,
	"./ICE/valve.png": 158,
	"./ICE/valveCam.png": 159,
	"./ICE/wasteGas.png": 613,
	"./IdealGas/background-Chart1.png": 1849,
	"./IdealGas/background-Chart2.png": 1850,
	"./IdealGas/background-Chart3.png": 1851,
	"./IdealGas/bg1-3.png": 587,
	"./IdealGas/bg_Isobar_isochore.png": 589,
	"./IdealGas/bg_adiabat.png": 590,
	"./IdealGas/bg_isotherm.png": 588,
	"./IdealGas/blue_ball.png": 205,
	"./IdealGas/blue_ballon.png": 1852,
	"./IdealGas/grey_ball.png": 1853,
	"./IdealGas/light_grey_ball.png": 1854,
	"./IdealGas/piston.png": 1855,
	"./IdealGas/piston_case - Copy.png": 1856,
	"./IdealGas/piston_case.png": 1857,
	"./IdealGas/red_ball.png": 157,
	"./IdealGas/red_ballon.png": 1858,
	"./IdealGas/white_ball.png": 1859,
	"./XY.png": 1860,
	"./add_task_to_homework.png": 745,
	"./allLifting/bowl.png": 266,
	"./allLifting/briks.png": 101,
	"./allLifting/cargo.png": 746,
	"./allLifting/concreteMixer.png": 265,
	"./allLifting/liftingMethod1.png": 1861,
	"./allLifting/liftingMethod2.png": 1862,
	"./allLifting/liftingMethod3.png": 1863,
	"./allLifting/liftingMethod4.png": 1864,
	"./allLifting/liftingMethod5.png": 1865,
	"./allLifting/liftingMethod6.png": 1866,
	"./allLifting/liftingMethod7.png": 1867,
	"./allLifting/liftingMethod8.png": 1868,
	"./allLifting/piano.png": 100,
	"./allLifting/star.png": 747,
	"./allLifting/star_opacity.png": 748,
	"./balloon/noAirBaloon.png": 604,
	"./balloon/noBaloon.png": 603,
	"./balloon/redBall.png": 601,
	"./balloon/redBall2.png": 602,
	"./balloon/redBall3.png": 1869,
	"./beaker/beaker1.png": 258,
	"./beaker/beaker2.png": 719,
	"./beaker/beaker3.png": 279,
	"./bondGas/Asset 47.png": 1870,
	"./bondGas/Chip.png": 749,
	"./bondGas/base.png": 750,
	"./bondGas/dark_green_ball.png": 751,
	"./bondGas/flask.png": 752,
	"./bondGas/flaskCold.png": 753,
	"./bondGas/flaskHot.png": 754,
	"./bondGas/gasBox.png": 755,
	"./bondGas/piton.png": 756,
	"./bondGas/rotateArrow.png": 330,
	"./bondGas/stick.png": 757,
	"./bondGas/tempBox.png": 758,
	"./bondGas/tempSlide.png": 759,
	"./bondGas/wheel.png": 1871,
	"./bondGas/wheelHandle.png": 1872,
	"./bondGas/wheelHandle2.png": 760,
	"./bondGas/wheelRect.png": 761,
	"./bondSubmarine/airBg.png": 762,
	"./bondSubmarine/breakSubmarine.png": 365,
	"./bondSubmarine/fish-1.png": 992,
	"./bondSubmarine/fish-10.png": 993,
	"./bondSubmarine/fish-11.png": 994,
	"./bondSubmarine/fish-12.png": 995,
	"./bondSubmarine/fish-13.png": 996,
	"./bondSubmarine/fish-14.png": 997,
	"./bondSubmarine/fish-15.png": 998,
	"./bondSubmarine/fish-16.png": 999,
	"./bondSubmarine/fish-17.png": 1000,
	"./bondSubmarine/fish-18.png": 1001,
	"./bondSubmarine/fish-19.png": 1002,
	"./bondSubmarine/fish-2.png": 1003,
	"./bondSubmarine/fish-20.png": 1004,
	"./bondSubmarine/fish-21.png": 1005,
	"./bondSubmarine/fish-22.png": 1006,
	"./bondSubmarine/fish-23.png": 1007,
	"./bondSubmarine/fish-3.png": 1008,
	"./bondSubmarine/fish-4.png": 1009,
	"./bondSubmarine/fish-5.png": 1010,
	"./bondSubmarine/fish-6.png": 1011,
	"./bondSubmarine/fish-7.png": 1012,
	"./bondSubmarine/fish-8.png": 1013,
	"./bondSubmarine/fish-9.png": 1014,
	"./bondSubmarine/patter1.png": 763,
	"./bondSubmarine/pattern2.png": 764,
	"./bondSubmarine/submarine.png": 765,
	"./bondSubmarine/underwaterBase.png": 766,
	"./brakingDistances/1.png": 767,
	"./brakingDistances/2.png": 768,
	"./brakingDistances/3.png": 769,
	"./brakingDistances/auto.png": 770,
	"./brakingDistances/background.png": 771,
	"./brakingDistances/btnDown.png": 772,
	"./brakingDistances/btnUp.png": 773,
	"./brakingDistances/cargo.png": 774,
	"./brakingDistances/formulas.png": 775,
	"./brakingDistances/road.png": 776,
	"./brakingDistances/wheel.png": 777,
	"./brickFactory/background.png": 640,
	"./brickFactory/borderHorizontal.png": 642,
	"./brickFactory/borderVertical.png": 641,
	"./brickFactory/brick1.png": 643,
	"./brickFactory/brick2.png": 644,
	"./brickFactory/controll3.png": 647,
	"./brickFactory/dispenser.png": 646,
	"./brickFactory/kiln.png": 645,
	"./brickFactory/line 2.png": 1873,
	"./brickFactory/line.png": 1874,
	"./brownianMotion/blueGasCylinder.png": 592,
	"./brownianMotion/fire.png": 1875,
	"./brownianMotion/ground.png": 597,
	"./brownianMotion/indicator.png": 594,
	"./brownianMotion/pistion.png": 595,
	"./brownianMotion/pistonCase.png": 593,
	"./brownianMotion/redGasCylinder.png": 591,
	"./brownianMotion/scene.png": 328,
	"./brownianMotion/tube.png": 596,
	"./bus/bus.png": 778,
	"./bus/busBg.png": 779,
	"./bus/darkBus.png": 780,
	"./bus/dialogGreen.png": 366,
	"./bus/dialogRed.png": 367,
	"./bus/gas.png": 781,
	"./bus/house1.png": 1015,
	"./bus/house10.png": 1016,
	"./bus/house11.png": 1017,
	"./bus/house12.png": 1018,
	"./bus/house13.png": 1019,
	"./bus/house2.png": 1020,
	"./bus/house3.png": 1021,
	"./bus/house4.png": 1022,
	"./bus/house5.png": 1023,
	"./bus/house6.png": 1024,
	"./bus/house7.png": 1025,
	"./bus/house8.png": 1026,
	"./bus/house9.png": 1027,
	"./bus/human1.png": 782,
	"./bus/human2.png": 783,
	"./bus/human3.png": 784,
	"./bus/human4.png": 785,
	"./bus/human5.png": 786,
	"./bus/human6.png": 787,
	"./bus/human7.png": 788,
	"./bus/human8.png": 789,
	"./bus/human9.png": 790,
	"./bus/indicator.png": 791,
	"./bus/indicatorLine.png": 792,
	"./bus/lawn.png": 1876,
	"./bus/light.png": 793,
	"./bus/road.png": 1877,
	"./bus/sidewalk.png": 1878,
	"./bus/sky.png": 794,
	"./bus/stop.png": 795,
	"./bus/stopLight.png": 796,
	"./bus/sun.png": 797,
	"./bus/tree.png": 798,
	"./bus/tree2.png": 799,
	"./bus/tunnel.png": 800,
	"./bus/wheel.png": 801,
	"./bus/windowLight.png": 802,
	"./bus/окна - под автобусом но над людьми.png": 1879,
	"./bus/поверх домов.png": 1880,
	"./chemistry/liquid.png": 692,
	"./chemistry/pointer.png": 693,
	"./chemistry/scene.png": 691,
	"./cityLighting/2Asset 8.png": 1881,
	"./cityLighting/Asset 4.png": 1882,
	"./cityLighting/Mountain.png": 630,
	"./cityLighting/backgroundDay.png": 632,
	"./cityLighting/backgroundNight.png": 631,
	"./cityLighting/buildings.png": 633,
	"./cityLighting/buildingsLight.png": 634,
	"./cityLighting/powerCable1.png": 638,
	"./cityLighting/powerCable2.png": 639,
	"./cityLighting/station.png": 636,
	"./cityLighting/transformer.png": 635,
	"./cityLighting/water.png": 637,
	"./crane/background.png": 162,
	"./crane/bigWheel.png": 656,
	"./crane/box.png": 164,
	"./crane/boxes.png": 165,
	"./crane/boxesCrane6.png": 166,
	"./crane/boxesCrane7.png": 244,
	"./crane/crane.png": 167,
	"./crane/cross.png": 245,
	"./crane/engine.png": 168,
	"./crane/hook.png": 169,
	"./crane/info.png": 246,
	"./crane/switchBtn.png": 530,
	"./crane/switchTrackGreen.png": 531,
	"./crane/switchTrackPurple.png": 532,
	"./crane/wheel.png": 163,
	"./crane/withScenario/controller.png": 655,
	"./crown/background1.png": 537,
	"./crown/background2.png": 538,
	"./crown/background3.png": 539,
	"./crown/crown.png": 234,
	"./crown/crownScale/Asset 66.png": 1883,
	"./crown/crownScale/Asset 71.png": 1884,
	"./crown/crownScale/weight100.png": 357,
	"./crown/crownScale/weight1000.png": 358,
	"./crown/crownScale/weight20.png": 356,
	"./crown/dinamometr.png": 540,
	"./crown/hook.png": 541,
	"./curvedArrow.png": 744,
	"./dynamometer/box.png": 649,
	"./dynamometer/dynamometer.png": 650,
	"./dynamometer/dynamometerEn.png": 651,
	"./dynamometer/ground.png": 652,
	"./dynamometer/hook.png": 653,
	"./dynamometer/pointer.png": 648,
	"./dynamometer/smallHook.png": 654,
	"./efficiency/oilBottle.png": 311,
	"./electrostatic/ball.png": 675,
	"./electrostatic/electroscope.png": 250,
	"./electrostatic/electroscopeBall.png": 680,
	"./electrostatic/minus.png": 178,
	"./electrostatic/negative_wire.png": 678,
	"./electrostatic/neutral_wire.png": 679,
	"./electrostatic/plus.png": 177,
	"./electrostatic/positive_wire.png": 677,
	"./electrostatic/silverball.png": 676,
	"./electrostatic/stick.png": 681,
	"./endBtn.png": 965,
	"./failIcon.png": 155,
	"./fountain/Asset 1.png": 1885,
	"./fountain/Asset 2.png": 1886,
	"./fountain/Asset 6.png": 1887,
	"./fountain/Asset 7.png": 1888,
	"./fountain/Asset 8.png": 1889,
	"./fountain/empty_scene.png": 670,
	"./fountain/start_scene.png": 669,
	"./fountain/start_scene1.png": 1890,
	"./fountain/tower.png": 671,
	"./gearRatios/Asset 10.png": 1891,
	"./gearRatios/Asset 12.png": 1892,
	"./gearRatios/Asset 13.png": 1893,
	"./gearRatios/Asset 4.png": 1894,
	"./gearRatios/Asset 5.png": 1895,
	"./gearRatios/Asset 6.png": 1896,
	"./gearRatios/Asset 7.png": 1897,
	"./gearRatios/arrowGrey.png": 483,
	"./gearRatios/block.png": 494,
	"./gearRatios/bridge.png": 465,
	"./gearRatios/castle.png": 470,
	"./gearRatios/gates.png": 469,
	"./gearRatios/gearEngine1.png": 354,
	"./gearRatios/gearEngine2.png": 355,
	"./gearRatios/gearEngine3.png": 495,
	"./gearRatios/gearHigh.png": 475,
	"./gearRatios/gearSmall.png": 474,
	"./gearRatios/handle.png": 473,
	"./gearRatios/marathon.png": 486,
	"./gearRatios/person.png": 464,
	"./gearRatios/pirateShip.png": 463,
	"./gearRatios/river-background.png": 466,
	"./gearRatios/scaleStick.png": 230,
	"./gearRatios/scaleStick2.png": 231,
	"./gearRatios/scene.png": 1898,
	"./gearRatios/sheave.png": 228,
	"./gearRatios/sheaveGray.png": 468,
	"./gearRatios/statusBar1.png": 487,
	"./gearRatios/statusBar11.png": 488,
	"./gearRatios/statusBar2.png": 489,
	"./gearRatios/statusBar22.png": 490,
	"./gearRatios/statusBar3.png": 491,
	"./gearRatios/statusBar33.png": 492,
	"./gearRatios/textWeight.png": 485,
	"./gearRatios/tower.png": 472,
	"./gearRatios/triangle.png": 484,
	"./gearRatios/triangle2.png": 232,
	"./gearRatios/wall.png": 471,
	"./gearRatios/weight.png": 477,
	"./gearRatios/weight1.png": 479,
	"./gearRatios/weight2.png": 493,
	"./gearRatios/weight3.png": 480,
	"./gearRatios/weight5.png": 478,
	"./gearRatios/weightGruz.png": 482,
	"./gearRatios/weightQ.png": 481,
	"./grayCross.png": 89,
	"./grid.png": 1899,
	"./ground.png": 718,
	"./hintArrow.png": 229,
	"./hydraulicPress/1Asset 3.png": 1900,
	"./hydraulicPress/1Asset 4.png": 1901,
	"./hydraulicPress/1Asset 6.png": 1902,
	"./hydraulicPress/1Asset 7.png": 1903,
	"./hydraulicPress/1Asset 8.png": 1904,
	"./hydraulicPress/Asset 3.png": 1905,
	"./hydraulicPress/Asset 4.png": 1906,
	"./hydraulicPress/Asset 5.png": 1907,
	"./hydraulicPress/bar.png": 661,
	"./hydraulicPress/big_case.png": 657,
	"./hydraulicPress/big_piston.png": 664,
	"./hydraulicPress/case.png": 1908,
	"./hydraulicPress/cylinder.png": 665,
	"./hydraulicPress/fake_bar.png": 662,
	"./hydraulicPress/large_cylinder.png": 668,
	"./hydraulicPress/left_case.png": 658,
	"./hydraulicPress/pointer.png": 667,
	"./hydraulicPress/right_case.png": 659,
	"./hydraulicPress/small_piston.png": 663,
	"./hydraulicPress/stand.png": 660,
	"./hydraulicPress/top_bar.png": 666,
	"./hydraulicPress/Гидравлический пресс.png": 1909,
	"./ilustrations/illustration_block.png": 803,
	"./ilustrations/illustration_vorot.png": 804,
	"./island.png": 1910,
	"./islandWithPier.png": 1911,
	"./kineticEnergy/auto.png": 805,
	"./kineticEnergy/background.png": 806,
	"./kineticEnergy/btnDown.png": 807,
	"./kineticEnergy/btnUp.png": 808,
	"./kineticEnergy/cargo.png": 809,
	"./kineticEnergy/formulaKineticEnergy.png": 810,
	"./kineticEnergy/formulaMass.png": 811,
	"./kineticEnergy/formulaSpeed.png": 812,
	"./kineticEnergy/road.png": 813,
	"./kineticEnergy/wheel.png": 814,
	"./liftingBlocksMultiple/liftingMethod1.png": 1912,
	"./liftingBlocksMultiple/liftingMethod2.png": 1913,
	"./liftingBlocksMultiple/liftingMethod3.png": 1914,
	"./liftingInclinedSurface/liftingMethod1.png": 1915,
	"./liftingInclinedSurface/liftingMethod2.png": 1916,
	"./liftingLoadMultiple/Asset 34.png": 1917,
	"./liftingLoadMultiple/Asset 36.png": 1918,
	"./liftingLoadMultiple/Asset 37.png": 1919,
	"./liftingLoadMultiple/Asset 38.png": 1920,
	"./liftingLoadMultiple/Asset 40.png": 1921,
	"./liftingLoadMultiple/Asset 43.png": 1922,
	"./liftingLoadMultiple/Asset 64.png": 1923,
	"./liftingLoadMultiple/Asset 68.png": 1924,
	"./liftingLoadMultiple/background.png": 259,
	"./liftingLoadMultiple/cargo.png": 196,
	"./liftingLoadMultiple/cargo2.png": 1925,
	"./liftingLoadMultiple/hook.png": 1926,
	"./liftingLoadMultiple/liftingMethod1.png": 1927,
	"./liftingLoadMultiple/liftingMethod2.png": 1928,
	"./liftingLoadMultiple/liftingMethod3.png": 1929,
	"./liftingLoadMultiple/liftingMethod4.png": 1930,
	"./liftingLoadMultiple/springboard.png": 264,
	"./liftingLoadMultiple/supportStand.png": 263,
	"./liftingLoadMultiple/triangleGray.png": 261,
	"./liftingLoadMultiple/wheel.png": 260,
	"./liftingLoadMultiple/windingArrow.png": 262,
	"./loop/background.png": 626,
	"./loop/car.png": 629,
	"./loop/jeep.png": 628,
	"./loop/wheel.png": 627,
	"./lvlComplete.png": 815,
	"./momentRules/weight1.png": 1028,
	"./momentRules/weight2.png": 1029,
	"./momentRules/weight3.png": 1030,
	"./momentRules/weight4.png": 1031,
	"./momentRules/weight5.png": 1032,
	"./mountains/air.png": 816,
	"./mountains/bgLab.png": 817,
	"./mountains/lab.png": 818,
	"./mountains/mountains.png": 819,
	"./mountains/table.png": 820,
	"./movableFixedBLock/Asset 14.png": 1931,
	"./movableFixedBLock/Asset 15.png": 1932,
	"./movableFixedBLock/Asset 16.png": 1933,
	"./movableFixedBLock/Asset 7.png": 1934,
	"./movableFixedBLock/F1.png": 821,
	"./movableFixedBLock/F2.png": 822,
	"./movableFixedBLock/formula1.png": 368,
	"./movableFixedBLock/formula2.png": 369,
	"./movableFixedBLock/l1.png": 823,
	"./movableFixedBLock/l2.png": 824,
	"./movableFixedBLock/movableBlock.png": 825,
	"./movableFixedBLock/topBlock.png": 826,
	"./movableFixedBLock/weight5.png": 827,
	"./oscillation/background.png": 624,
	"./pathandspeed/biker1.png": 251,
	"./pathandspeed/biker2.png": 695,
	"./pathandspeed/cars/background.png": 713,
	"./pathandspeed/cars/blueMark.png": 988,
	"./pathandspeed/cars/carBlue.png": 712,
	"./pathandspeed/cars/carGreen.png": 711,
	"./pathandspeed/cars/carRed.png": 710,
	"./pathandspeed/cars/chartPathBig.png": 708,
	"./pathandspeed/cars/chartPathSmall.png": 1935,
	"./pathandspeed/cars/chartSpeedBig.png": 709,
	"./pathandspeed/cars/chartSpeedSmall.png": 1936,
	"./pathandspeed/cars/greenMark.png": 989,
	"./pathandspeed/cars/redMark.png": 990,
	"./pathandspeed/chart.png": 694,
	"./pathandspeed/complete.png": 170,
	"./pathandspeed/mainCharForError1.png": 700,
	"./pathandspeed/mainCharForError2.png": 701,
	"./pathandspeed/mainCharStairway.png": 364,
	"./pathandspeed/mainChart.png": 696,
	"./pathandspeed/mainChartDescr1.png": 702,
	"./pathandspeed/mainChartDescr2.png": 703,
	"./pathandspeed/pathAndSpeed6/mainChart1.png": 84,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError1.png": 704,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError2.png": 705,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError3.png": 706,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError4.png": 707,
	"./pathandspeed/pathAndSpeed6/mainChart2.png": 276,
	"./pathandspeed/pathAndSpeed6/mainChart2Descr1.png": 277,
	"./pathandspeed/pathAndSpeed6/mainChart2Descr2.png": 278,
	"./pathandspeed/rightChart.png": 697,
	"./pathandspeed/road.png": 329,
	"./pathandspeed/space/Asset 8.png": 1937,
	"./pathandspeed/space/Asset 9.png": 1938,
	"./pathandspeed/space/background.png": 256,
	"./pathandspeed/space/chart1.png": 179,
	"./pathandspeed/space/chart1ForPoints.png": 181,
	"./pathandspeed/space/chart2.png": 180,
	"./pathandspeed/space/chart2ForPoints.png": 182,
	"./pathandspeed/space/craters.png": 699,
	"./pathandspeed/space/engin.png": 257,
	"./pathandspeed/space/exclamationIcon.png": 716,
	"./pathandspeed/space/ship.png": 717,
	"./pathandspeed/space/ship2.png": 252,
	"./pathandspeed/successArrow.png": 698,
	"./pathandspeed/train/arrowGrey.png": 255,
	"./pathandspeed/train/background.png": 253,
	"./pathandspeed/train/background2.png": 714,
	"./pathandspeed/train/timer.png": 171,
	"./pathandspeed/train/timer2.png": 1939,
	"./pathandspeed/train/timerEn.png": 715,
	"./pathandspeed/train/train.png": 172,
	"./pathandspeed/train/train2.png": 173,
	"./pathandspeed/train/trainSpeed.png": 254,
	"./peryshkinDam/aeroplane.png": 828,
	"./peryshkinDam/background.png": 829,
	"./peryshkinDam/backgroundHelper.png": 830,
	"./peryshkinDam/mechanism.png": 831,
	"./peryshkinDam/wheelContainer.png": 832,
	"./pier.png": 1940,
	"./play.png": 833,
	"./popupImage.png": 1941,
	"./positiveNegativeWork/background.png": 737,
	"./positiveNegativeWork/bolid.png": 740,
	"./positiveNegativeWork/ground.png": 738,
	"./positiveNegativeWork/indicator.png": 739,
	"./power1W/background.png": 730,
	"./power1W/car.png": 734,
	"./power1W/controller.png": 732,
	"./power1W/formula.png": 731,
	"./power1W/hookStart.png": 736,
	"./power1W/timer.png": 735,
	"./power1W/wheel.png": 733,
	"./powerExample/electricalAppliances.png": 834,
	"./powerExample/motors.png": 835,
	"./rally/background.png": 598,
	"./rally/car.png": 600,
	"./rally/monitor.png": 1942,
	"./rally/plane.png": 599,
	"./redcorss.png": 836,
	"./relativeMotion/chema/bg.png": 370,
	"./relativeMotion/chema/meteor.png": 371,
	"./relativeMotion/chema/planet.png": 372,
	"./relativeMotion/chema/rocket.png": 373,
	"./relativeMotion/chema/spaceShip.png": 374,
	"./relativeMotion/task/asteroid.png": 837,
	"./relativeMotion/task/bg.png": 838,
	"./relativeMotion/task/plant.png": 839,
	"./relativeMotion/task/rocket.png": 840,
	"./relativeMotion/task/ship.png": 841,
	"./scaleForCubes/aluminum.png": 227,
	"./scaleForCubes/brick.png": 313,
	"./scaleForCubes/cork.png": 314,
	"./scaleForCubes/differentVolume/brick.png": 513,
	"./scaleForCubes/differentVolume/gold.png": 514,
	"./scaleForCubes/differentVolume/oak.png": 515,
	"./scaleForCubes/differentVolume/silver.png": 516,
	"./scaleForCubes/gold.png": 315,
	"./scaleForCubes/ice.png": 316,
	"./scaleForCubes/oak.png": 317,
	"./scaleForCubes/silver.png": 318,
	"./scaleForCubes/steel.png": 319,
	"./scales/base.png": 510,
	"./scales/lever.png": 511,
	"./scales/platform.png": 512,
	"./scales/weight10.png": 505,
	"./scales/weight100.png": 508,
	"./scales/weight20.png": 506,
	"./scales/weight5.png": 504,
	"./scales/weight50.png": 507,
	"./scales/weightQ1.png": 312,
	"./scales/weightQ2.png": 233,
	"./skiBond/background2.png": 842,
	"./snowboard/background.png": 843,
	"./snowboard/indicator.png": 844,
	"./snowboard/mainInfoFormula.png": 845,
	"./snowboard/man.png": 846,
	"./snowboard/speedFormula.png": 847,
	"./snowboard/track.png": 848,
	"./snowboard/trackL.png": 375,
	"./snowboard/trackR.png": 849,
	"./snowboard/tree.png": 850,
	"./socialArrow.png": 851,
	"./space.png": 625,
	"./space/answerWindow.png": 1943,
	"./space/exclamationIcon.png": 1944,
	"./space/jumping_on_planets/background.png": 569,
	"./space/jumping_on_planets/planet1.png": 570,
	"./space/jumping_on_planets/planet2.png": 571,
	"./space/jumping_on_planets/planet3.png": 572,
	"./space/jumping_on_planets/planet4.png": 573,
	"./space/jumping_on_planets/planet5.png": 574,
	"./space/loss_satellite/Asset 150.png": 1945,
	"./space/loss_satellite/Asset 151.png": 1946,
	"./space/loss_satellite/background.png": 575,
	"./space/path_and_speed/Asset 34.png": 1947,
	"./space/path_and_speed/Asset 35.png": 1948,
	"./space/path_and_speed/Asset 36.png": 1949,
	"./space/path_and_speed/Asset 38.png": 1950,
	"./space/path_and_speed/Asset 40.png": 1951,
	"./space/repulsion_of_bodies/astronautArm.png": 579,
	"./space/repulsion_of_bodies/astronautBody.png": 578,
	"./space/repulsion_of_bodies/dashCircle.png": 1952,
	"./space/repulsion_of_bodies/fatMan.png": 582,
	"./space/repulsion_of_bodies/shadowAstronaut1.png": 240,
	"./space/repulsion_of_bodies/shadowAstronaut2.png": 581,
	"./space/repulsion_of_bodies/shadowSpaceship.png": 577,
	"./space/repulsion_of_bodies/strongMan.png": 583,
	"./space/repulsion_of_bodies/wholeAstronaut.png": 580,
	"./space/spaceBackground.png": 238,
	"./space/spaceBackground2.png": 239,
	"./space/spaceship.png": 576,
	"./space/spaceship_asteroid_1/Asset 33.png": 1953,
	"./space/spaceship_asteroid_1/Asset 34.png": 1954,
	"./space/spaceship_asteroid_1/asteroid.png": 327,
	"./space/spaceship_asteroid_1/btnDown.png": 325,
	"./space/spaceship_asteroid_1/btnTop.png": 324,
	"./space/spaceship_asteroid_1/engine.png": 237,
	"./space/spaceship_asteroid_1/planeta1.png": 562,
	"./space/spaceship_asteroid_1/planeta2.png": 563,
	"./space/spaceship_asteroid_1/planeta3.png": 564,
	"./space/spaceship_asteroid_1/planeta4.png": 969,
	"./space/spaceship_asteroid_1/planeta5.png": 970,
	"./space/spaceship_asteroid_1/planeta6.png": 971,
	"./space/spaceship_asteroid_1/planeta7.png": 972,
	"./space/spaceship_asteroid_1/pointItem.png": 326,
	"./space/spaceship_asteroid_1/spaceship.png": 561,
	"./space/spaceship_asteroid_2/dialog.png": 568,
	"./space/spaceship_asteroid_2/dude.png": 567,
	"./space/spaceship_asteroid_2/planet1.png": 1955,
	"./space/spaceship_asteroid_2/pointItemImg.png": 1956,
	"./space/spaceship_asteroid_2/spaceship.png": 360,
	"./space/spaceship_asteroid_2/stantionBig.png": 565,
	"./space/spaceship_asteroid_2/stantionSMall.png": 566,
	"./space/spaceship_landing/Asset 137.png": 1957,
	"./space/spaceship_landing/Asset 63.png": 1958,
	"./space/spaceship_landing/Asset 64.png": 1959,
	"./space/spaceship_landing/Asset 71.png": 1960,
	"./space/spaceship_landing/Asset 72.png": 1961,
	"./space/spaceship_landing/btn-left.png": 137,
	"./space/spaceship_landing/btn-right.png": 138,
	"./space/spaceship_landing/btn-top.png": 156,
	"./space/spaceship_landing/cyberpunk-btn.png": 550,
	"./space/spaceship_landing/cyberpunk-form.png": 549,
	"./space/spaceship_landing/engine-fire.png": 543,
	"./space/spaceship_landing/landing-place.png": 544,
	"./space/spaceship_landing/living-module.png": 545,
	"./space/spaceship_landing/ship-inside.png": 1962,
	"./space/spaceship_landing/spaceship.png": 322,
	"./space/spaceship_landing/stantion-1.png": 546,
	"./space/spaceship_landing/stantion-2.png": 547,
	"./space/spaceship_landing/Элементы ветра/shape-1.png": 1963,
	"./space/spaceship_landing/Элементы ветра/shape-2.png": 1964,
	"./space/spaceship_landing/Элементы ветра/shape-3.png": 1965,
	"./space/spaceship_landing/Элементы ветра/shape-4.png": 1966,
	"./space/spaceship_landing/Элементы ветра/shape-5.png": 1967,
	"./space/spaceship_landing/Элементы ветра/shape-6.png": 1968,
	"./space/spaceship_landing/Элементы ветра/shape-7.png": 1969,
	"./space/spaceship_landing/Элементы ветра/shape-8.png": 1970,
	"./space/spaceship_landing/Элементы ветра/shape-9.png": 1971,
	"./space/spaceship_take_off/Asset 146.png": 1972,
	"./space/spaceship_take_off/answerWindow.png": 236,
	"./space/spaceship_take_off/btnFuel.png": 558,
	"./space/spaceship_take_off/btnLeft.png": 559,
	"./space/spaceship_take_off/btnRight.png": 560,
	"./space/spaceship_take_off/btnStart.png": 557,
	"./space/spaceship_take_off/fuelIndicatorBorder.png": 556,
	"./space/spaceship_take_off/launchFacility.png": 552,
	"./space/spaceship_take_off/launchGround.png": 553,
	"./space/spaceship_take_off/launchServiceFarm.png": 554,
	"./space/spaceship_take_off/spaceship.png": 551,
	"./space/spaceship_take_off/spshipTraectory.png": 555,
	"./space/spaceship_take_off/traectoryLine.png": 1973,
	"./space/spaceship_take_off/traectoryLine2.png": 1974,
	"./space/theory/Asset 86.png": 462,
	"./space/theory/background.png": 194,
	"./space/theory/dialogArrow.png": 323,
	"./space/theory/theoryQ1.png": 548,
	"./star.png": 852,
	"./startBtn.png": 964,
	"./steamEngine/cork.png": 586,
	"./steamEngine/flask1-background.png": 584,
	"./steamEngine/flask2-background.png": 585,
	"./steamEngine/piston-task-2.png": 241,
	"./steamEngine/piston.png": 497,
	"./steamEngine/steam_box.png": 501,
	"./steamEngine/steam_tube_1.png": 502,
	"./steamEngine/steam_tube_2.png": 503,
	"./steamEngine/stick.png": 498,
	"./steamEngine/switch.png": 500,
	"./steamEngine/water_box.png": 499,
	"./steamEngine/wheel.png": 496,
	"./submarine/FarchAsset.png": 522,
	"./submarine/FtyazhAsset.png": 523,
	"./submarine/GameAsset 17.png": 1975,
	"./submarine/GameAsset 18.png": 1976,
	"./submarine/PodlozhkaAsset.png": 1977,
	"./submarine/againButton3.png": 521,
	"./submarine/boat1.png": 517,
	"./submarine/boat2.png": 518,
	"./submarine/boundaries.png": 520,
	"./submarine/boundariesBig.png": 529,
	"./submarine/checkButton.png": 524,
	"./submarine/data.png": 519,
	"./submarine/step2/background.png": 1978,
	"./submarine/step2/background2.png": 535,
	"./submarine/step2/boat-form.png": 533,
	"./submarine/step2/experiment 1-1.png": 1979,
	"./submarine/step2/experiment 1-2.png": 1980,
	"./submarine/step2/submarine.png": 534,
	"./submarine/step2/tube-2.png": 536,
	"./submarine/step2/tube.png": 1981,
	"./submarine/step2/Вода для заливки формы.png": 1982,
	"./submarine/step2/прозрачная вода для колбы.png": 1983,
	"./submarine/step4/background.png": 1984,
	"./submarine/step4/example.png": 1985,
	"./submarine/step4/platform.png": 528,
	"./submarine/step4/stick.png": 527,
	"./submarine/step4/submarineWater.png": 1986,
	"./submarine/step4/submarineWaterBig.png": 1987,
	"./submarine/step4/submarineWaterBig2.png": 526,
	"./submarine/step4/triangle.png": 320,
	"./submarine/submarineRealBig.png": 525,
	"./success.png": 853,
	"./successArrow.png": 1988,
	"./successArrow2.png": 509,
	"./tgCircle/925-521Asset 15.png": 1989,
	"./tgCircle/936-521Asset 13.png": 1990,
	"./tgCircle/arrow.png": 1991,
	"./tgCircle/arrow_orange.png": 690,
	"./tgCircle/correct.png": 687,
	"./tgCircle/crcl.png": 686,
	"./tgCircle/dragcircl.png": 688,
	"./tgCircle/dragcirclOrange.png": 689,
	"./tgCircle/formulas.png": 1992,
	"./tgCircle/o.png": 684,
	"./tgCircle/one.png": 685,
	"./tgCircle/x.png": 683,
	"./tgCircle/y.png": 682,
	"./timeDependenceOfWork/Asset 4.png": 1993,
	"./timeDependenceOfWork/Asset 5.png": 1994,
	"./timeDependenceOfWork/background.png": 741,
	"./timeDependenceOfWork/cargo.png": 743,
	"./timeDependenceOfWork/hook.png": 742,
	"./timeDependenceOfWork/next.png": 1995,
	"./timeDependenceOfWork/play.png": 1996,
	"./timeDependenceOfWork/prev.png": 1997,
	"./timeDependenceOfWork/stop.png": 1998,
	"./toricelliExperiment/--.png": 1999,
	"./toricelliExperiment/1Asset 10.png": 2000,
	"./toricelliExperiment/backgroundGround.png": 672,
	"./toricelliExperiment/backgroundMountains.png": 673,
	"./toricelliExperiment/column.png": 247,
	"./toricelliExperiment/cork.png": 249,
	"./toricelliExperiment/scale.png": 674,
	"./toricelliExperiment/stand.png": 248,
	"./toricelliExperiment/Шаг 1.png": 2001,
	"./toricelliExperiment/Шаг 2.png": 2002,
	"./toricelliExperiment/Шаг 3.png": 2003,
	"./toricelliExperiment/Шаг 4.png": 2004,
	"./waterTower/buildings.png": 854,
	"./waterTower/card.png": 855,
	"./waterTower/ground.png": 856,
	"./waterTower/tubeBorder.png": 857,
	"./waterTower/waterTank.png": 858,
	"./waterTower/waterTowerBase.png": 859,
	"./wave.png": 235,
	"./whiteHintArrow.png": 476,
	"./whitelabel/eShaala_logo.png": 860,
	"./work1J/arrowDown.png": 721,
	"./work1J/arrowRight.png": 722,
	"./work1J/arrowSuccess.png": 723,
	"./work1J/arrowWidth.png": 724,
	"./work1J/background.png": 720,
	"./work1J/books.png": 725,
	"./work1J/cup.png": 726,
	"./work1J/formula.png": 727,
	"./work1J/tiazh.png": 729,
	"./work1J/trenie.png": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 991;